<script>
import BaseCheckbox from '../BaseCheckbox.vue';

export default {
  name: 'BaseCheckBoxList',
  components: { BaseCheckbox },
  props: {
    options: Array,
    value: Array,
  },
  data() {
    return {
      mutableValue: [],
    };
  },
  mounted() {
    this.mutableValue = [...this.value];
  },
  watch: {
    value: {
      handler(value) {
        this.mutableValue = [...value];
      },
    },
  },
  computed: {
    optionsCompiled() {
      if (!Array.isArray(this.options)) {
        return Object.entries(this.options).map(([value, label]) => ({ value, label }));
      }

      if (typeof this.options?.[0] !== 'object') {
        return this.options.map(v => ({ value: v, label: v }));
      }

      return this.options;
    },
  },
  methods: {
    updateValue(e) {
      if (this.mutableValue.includes(e)) {
        const index = this.mutableValue.indexOf(e);
        this.mutableValue.splice(index, 1);
      } else {
        this.mutableValue.push(e);
      }

      this.$emit('input', this.mutableValue);
      this.$emit('change', this.mutableValue);
    },
    setCheckBoxValue(value) {
      return this.mutableValue.includes(value);
    },
  },
};
</script>

<template lang="pug">
  .list
    BaseCheckbox(v-for="option in optionsCompiled" :key="option.value" :value="setCheckBoxValue(option.value)" :label="option.label" @input="updateValue(option.value)")
</template>

<style scoped lang="scss">
.list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
</style>
